import script from "./CampaignsList.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignsList.vue?vue&type=script&setup=true&lang=js"

import "./CampaignsList.vue?vue&type=style&index=0&id=10c5163a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c5163a"]])

export default __exports__